import request from '@/utils/request'

export function providerPage(params) {
  return request({
    url: '/mall/ordermanage/purchaseorderinfo/providerPage',
    method: 'post',
    params
  })
}
export function uploadImg(data) {
  return request({
    url: '/mall/uploadImg',
    method: 'post',
    data
  })
}

export function providerSave(data) {
  return request({
    url: '/mall/ordermanage/purchaseorderinfo/providerSave',
    method: 'post',
    data
  })
}

export function mallUserAddress(params) {
  return request({
    url: '/mall/codeSelect/mallUserAddress',
    method: 'post',
    params
  })
}

export function publishData(params) {
  return request({
    url: '/mall/ordermanage/purchaseorderinfo/providerPage',
    method: 'post',
    params
  })
}
// export function updateSalePrice(params) {
//   return request({
//     url: '/mall/mallmanage/providerOrder/updateSalePrice',
//     method: 'post',
//     headers:{
//       'Content-Type':'application/x-www-form-urlencoded;charset=UTF-8'
//     },
//     params
//   })
// }
